import { fromJS } from 'immutable';

import { successAction, failureAction } from '@utils/actions';
import { INIT_STORE } from '@shared/actionTypes';
import orderFlowReducer from '@core/utils/orderFlowReducer';
import { FETCH_SHOP_REVIEWS, CLEAN_STATE } from './actionTypes';

import ModuleStateModel from './model';

const initialState = ModuleStateModel;

function shopReviewsReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_STORE:
      return ModuleStateModel.mergeDeep(state);

    case FETCH_SHOP_REVIEWS:
      return state.set('isFetchingReviews', true);

    case failureAction(FETCH_SHOP_REVIEWS):
      return state.set('isFetchingReviews', false);

    case successAction(FETCH_SHOP_REVIEWS): {
      const { total, reviews } = action.payload;

      return state
        .set('isFetchingReviews', false)
        .set('total', total)
        .update('reviews', x => x.concat(fromJS(reviews)));
    }

    case CLEAN_STATE:
      return initialState;

    default:
      return state;
  }
}

export default orderFlowReducer(shopReviewsReducer, ModuleStateModel);
